<template>
  <div class="global-box customers">
    <div class="content-box">
      <h3>{{$t('index.customers.title')}}</h3>
      <div class="global-testemonial">
        <div v-for="(item, index) in testemonial" :key="index" class="unitary-testemonial">
          <p class="description">
            "{{item.description}}"
          </p>
          <div class="wraper-image">
            <a :href="item.link" target="_blank">
              <img
                :src="getImage(item.logo)"
                :alt="`logomarca ${item.name}`"
                class="brand-testemonial"
                :class="{
                  'social': item.logo === 'brandMuralSocial',
                  'rafaela': item.logo === 'brandRafaelaIngrid'
                }"
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customers',
  data() {
    return {
      testemonial: [
        {
          id: 1,
          name: 'Diatech Representação & Consultoria',
          logo: 'brandDiatech',
          description: this.$t('index.customers.description_diatech'),
          link: 'https://diatech.com.br',
        },
        {
          id: 2,
          name: 'Mural Social',
          logo: 'brandMuralSocial',
          description: this.$t('index.customers.description_mural'),
          link: 'https://mural.social',
        },
        {
          id: 4,
          name: 'Rafaela Ingrid Consultoria Contábil',
          logo: 'brandRafaelaIngrid',
          description: this.$t('index.customers.description_rafaela'),
          link: 'https://rafaelaingrid.com.br',
        },
      ],
    };
  },
  methods: {
    getImage(image) {
      /* eslint-disable */
        return require(`../assets/images/customers/${image}.svg`);
      /* eslint-enable */
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .customers
    min-height: 200px
    h3
      width: 100%
    .global-testemonial
      display: flex
      flex-wrap: nowrap
      justify-content: space-between
      margin-top: 32px
      .unitary-testemonial
        width: 30%
        display: flex
        flex-direction: column
        .description
          font-style: italic
          text-align: justify
        .custom
          width: 90%
          margin: 0 auto
          text-align: justify
        .wraper-image
          height: 100px
          display: flex
          justify-content: center
          align-items: center
          margin-top: 18px
          .brand-testemonial
            &.social
              height: 90px
            &.rafaela
              height: 50px
    @media (max-width: $widthTerciary)
      .global-testemonial
        flex-wrap: wrap
        justify-content: center
        .unitary-testemonial
          width: 100%
          margin-bottom: 18px
          &:not(:last-child)
            border-bottom: 1px solid $grey-200
          .wraper-image
            margin-bottom: 18px
</style>
